// Auto-logout configuration - Read environment variables dynamically
export const getAutoLogoutConfig = () => {
  const isDevelopment = import.meta.env.DEV
  
  // Read environment variables dynamically (not at build time)
  const productionTimeout = parseInt(import.meta.env.VITE_AUTO_LOGOUT_TIMEOUT_MINUTES || '15')
  const productionWarning = parseFloat(import.meta.env.VITE_AUTO_LOGOUT_WARNING_MINUTES || '1')
  const developmentTimeout = parseInt(import.meta.env.VITE_DEV_AUTO_LOGOUT_TIMEOUT_MINUTES || '2')
  const developmentWarning = parseFloat(import.meta.env.VITE_DEV_AUTO_LOGOUT_WARNING_MINUTES || '0.5')
  const enabled = import.meta.env.VITE_AUTO_LOGOUT_ENABLED !== 'false'

  return {
    timeoutMinutes: isDevelopment ? developmentTimeout : productionTimeout,
    warningMinutes: isDevelopment ? developmentWarning : productionWarning,
    enabled: enabled,
  }
}

// Legacy config object for backward compatibility
export const AUTO_LOGOUT_CONFIG = {
  TIMEOUT_MINUTES: parseInt(import.meta.env.VITE_AUTO_LOGOUT_TIMEOUT_MINUTES || '15'),
  WARNING_MINUTES: parseFloat(import.meta.env.VITE_AUTO_LOGOUT_WARNING_MINUTES || '1'),
  ENABLED: import.meta.env.VITE_AUTO_LOGOUT_ENABLED !== 'false',
  DEV_TIMEOUT_MINUTES: parseInt(import.meta.env.VITE_DEV_AUTO_LOGOUT_TIMEOUT_MINUTES || '2'),
  DEV_WARNING_MINUTES: parseFloat(import.meta.env.VITE_DEV_AUTO_LOGOUT_WARNING_MINUTES || '0.5'),
} as const 